import { FC, cloneElement, isValidElement, useState, useEffect, useCallback, ReactElement } from 'react';
import { Unselect } from '@clds/compound-components';
import { MobileMenu } from '@cld/mobile-menu';
import { DropdownMobileMenuProps } from './DropdownMobileMenu.types';
import { MobileMenuHeader } from './DropdownMobileMenuHeader';

export const DropdownMobileMenu: FC<DropdownMobileMenuProps> = ({
  dataTest = 'platform-menu-mobile',
  onToggleOpenStateChange,
  headerTitle,
  trigger,
  children,
  onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    void onToggleOpenStateChange?.(isOpen);
  }, [isOpen, onToggleOpenStateChange]);

  const toggleOpenState = () => setIsOpen((isOpen) => !isOpen);

  const onSelectCallback = useCallback(
    (id: string | Unselect) => {
      onSelect?.(id);
      toggleOpenState();
    },
    [onSelect]
  );

  return (
    <>
      {isValidElement(trigger) &&
        cloneElement(trigger as ReactElement, {
          onClick: toggleOpenState,
        })}
      {isOpen && (
        <MobileMenu
          menuDataTest={`menu-${dataTest}`}
          drawerDataTest={`drawer-${dataTest}`}
          backdropClickHandler={toggleOpenState}
          menuProps={{ onSelect: onSelectCallback }}
        >
          <MobileMenuHeader headerTitle={headerTitle} onClose={toggleOpenState} />
          {children}
        </MobileMenu>
      )}
    </>
  );
};
